import { CustomValueOption, CustomValuesEditField } from "PFApp/components/custom_values_edit_field";
import { allowsNewValues } from "PFCore/helpers/custom_type";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { CreateCustomValueData, CreateCustomValueResponse } from "PFCore/services/custom_values";
import { CustomType, CustomValueScope, FeatureFlag, Id } from "PFTypes";

import { useCustomValuePreviewContext } from "../context/custom_value_preview_context";

type CustomValueSelectProps = {
  customType: CustomType;
  customValuesIdsBlacklist?: Id[];
  createCustomValue: (data: CreateCustomValueData) => Promise<CreateCustomValueResponse>;
};

export const CustomValueSelect = ({
  customType,
  customValuesIdsBlacklist,
  createCustomValue
}: CustomValueSelectProps) => {
  const { connectedValuesIds, scope, setSelectedCustomValueId } = useCustomValuePreviewContext();
  const isActivityCanCreateValuesEnabled = useIsFeatureEnabled(FeatureFlag.ActivityCanCreateValues);
  const letCreate =
    (scope !== CustomValueScope.Activity || isActivityCanCreateValuesEnabled) && allowsNewValues(customType);

  const handleChange = async (values) => {
    const selectedCustomValue = values[0];

    if (!selectedCustomValue) {
      return;
    }

    let selectedCustomValueId = selectedCustomValue.id;

    if (selectedCustomValue.created) {
      const { id } = await createCustomValue({
        payload: {
          customTypeId: customType.id,
          value: selectedCustomValue.id
        }
      });

      selectedCustomValueId = id;
    }

    setSelectedCustomValueId(selectedCustomValueId);
  };

  return (
    <CustomValuesEditField
      label={customType.display_as}
      letCreate={letCreate}
      multi={false}
      hasValuesWithExpiryDate={false}
      forceUnlocked
      customType={customType}
      connectedValuesIds={connectedValuesIds}
      parseOptions={(options: CustomValueOption[]) =>
        options.filter(({ original: { id } }) => !(customValuesIdsBlacklist || []).includes(id))
      }
      handleChange={handleChange}
    />
  );
};
